import {SORTABLE_POSITION} from '../../constants';

import type {SortablePosition} from '../../typedef';


type GetActiveSide = ({size, cursorPosition}: Record<string, number>) => SortablePosition | undefined;

export const getActiveSide: GetActiveSide = ({size, cursorPosition}) => {
    if (cursorPosition > size / 2) {
        return SORTABLE_POSITION.AFTER;
    } else if (cursorPosition <= size / 2) {
        return SORTABLE_POSITION.BEFORE;
    }
};
